<template>
  <div
    data-component-group="package-form"
    data-component="package-submission-limits"
  >
    <slot name="beforeForm" />

    <SubmissionLimitsForm
      :limit="packageItem"
      :limits="limits"
      :countries="countries"
      :is-disabled="isDisabled"
      :on-submit="onSubmit"
      :on-remove="onRemove"
      :trigger-icon="triggerIcon"
      :trigger-label="triggerLabel"
    />
  </div>
</template>

<script>
  import SubmissionLimitsForm from '../SubmissionLimits';

  // TODO: Translate component

  export default {
    components: {
      SubmissionLimitsForm,
    },
    props: {
      packageItem: {
        type: Object,
        default: undefined,
      },
      limits: {
        type: Array,
        default() {
          return [];
        },
      },
      triggerIcon: {
        type: String,
        default: 'edit',
      },
      triggerLabel: {
        type: String,
        default: 'Enable',
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
      onRemove: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      countries() {
        return this.$store.getters['users/countries'];
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='package-form'][data-component='package-submission-limits'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);
}
</style>
